export default __webpack_public_path__ + "static/media/Peixoto.972ca3b1.jpg";